import api from '@/services/api'

export default {
    fetchOrder(id) {
        return api.get(`api/porting_orders/${id}/`)
            .then(response => response.data)
    },
    fetchOrders(params) {
        return api.get('api/porting_orders/', {params: params})
            .then(response => response.data)
    },
    postOrder(payload) {
        return api.post('api/porting_orders/', payload)
            .then(response => response.data)
    },
    patchOrder(id, payload) {
        return api.patch(`api/porting_orders/${id}/`, payload)
            .then(response => response.data)
    }
}